import React from 'react'
import { DashboardTableHeader } from './dashboard-table-header'
import { OrgDashboardSectionKey, SectionHeadingElementIdContext, sectionHeadingElementId } from './section-well'
import './org-dashboard.scss'

type Props = {
    sectionKey: OrgDashboardSectionKey
    title: string
    filters?: React.ReactNode
    actions?: React.ReactNode
    /** A note about the table below it, so the header stays a title and its controls. */
    footnote?: React.ReactNode
    children: React.ReactNode
}

/**
 * The one contained surface for a dashboard table: a DataView-style header over the table, a region labelled by the
 * header's title. The header sits outside whatever the body is showing (rows, placeholder rows, a failure message),
 * so it is the same element in every state: nothing moves when the rows arrive, and the title keeps keyboard focus
 * through a retry (a failure message inside it moves focus there). It belongs inside a TableSectionWell, whose DataView class the header's styling hangs on.
 */
export const DashboardTableCard: React.FC<Props> = ({ sectionKey, title, filters, actions, footnote, children }) => (
    <section className="org-dashboard-card" aria-labelledby={sectionHeadingElementId(sectionKey)}>
        <div className="org-dashboard-table-card-header">
            <DashboardTableHeader sectionKey={sectionKey} title={title} filters={filters} actions={actions} />
        </div>
        <SectionHeadingElementIdContext.Provider value={sectionHeadingElementId(sectionKey)}>
            {children}
        </SectionHeadingElementIdContext.Provider>
        {footnote ? <div className="org-dashboard-table-card-footnote">{footnote}</div> : null}
    </section>
)
